/** @typedef {import("./types/thinking-step-types.js").ThinkingTask} ThinkingTask */

/** Internal tool calls that should never appear in the thinking accordion. */
export function isHiddenThinkingToolTask(task) {
  if (task.toolName === "request_more_tools") return true;
  if (/^request more tools$/i.test(String(task.title ?? "").trim())) return true;
  return false;
}

/** Reasoning / placeholder rows hidden from the completed thinking accordion. */
export function isEphemeralThinkingTask(task) {
  if (task.openChatPreferencesLink) return false;
  if (isHiddenThinkingToolTask(task)) return true;
  if (task.id === "thinking-placeholder") return true;
  if (task.icon === "brain") return true;
  return false;
}

/**
 * @param {ThinkingTask[]} tasks
 */
export function countSubstantiveThinkingTasks(tasks) {
  return tasks.filter((task) => !isEphemeralThinkingTask(task)).length;
}

/**
 * @param {ThinkingTask[]} tasks
 * @param {boolean} hasRunning
 */
export function buildThinkingStepTaskCountTitle(tasks, hasRunning) {
  const count = countSubstantiveThinkingTasks(tasks);
  if (hasRunning) {
    if (count === 0) return "Working...";
    return `Working on ${count} task${count !== 1 ? "s" : ""}...`;
  }
  return "Completed tasks";
}
